var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _polygon, _path22, _polygon2, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowcaseIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 275.15 230.42",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 206.37,
    y1: 182.09,
    x2: 201.84,
    y2: 123.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 161.38,
    y1: 150.67,
    x2: 212.51,
    y2: 126.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 121.93,
    y1: 260.13,
    x2: 100.9,
    y2: -112.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 183.75,
    y1: 256.64,
    x2: 162.71,
    y2: -115.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 955.21,
    y1: 145.56,
    x2: 974.46,
    y2: 155.11,
    gradientTransform: "matrix(-1, 0, 0, 1, 1129.59, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 939.55,
    y1: 170.59,
    x2: 950.72,
    y2: 145.46,
    gradientTransform: "matrix(-1, 0, 0, 1, 1129.59, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 957.62,
    y1: 86.47,
    x2: 1028.45,
    y2: 184.64,
    gradientTransform: "matrix(-1, 0, 0, 1, 1129.59, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 154.75,
    y1: 76.42,
    x2: 111.3,
    y2: 139.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 983.37,
    y1: 56.47,
    x2: 992.55,
    y2: 76.53,
    gradientTransform: "matrix(-1, 0, 0, 1, 1129.59, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 71.9,
    y1: 164.55,
    x2: 67.36,
    y2: 106.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 26.9,
    y1: 133.12,
    x2: 78.04,
    y2: 109.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 202.92,
    y1: 106.43,
    x2: 198.38,
    y2: 48.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 157.92,
    y1: 75.01,
    x2: 209.05,
    y2: 51.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 153.88,
    y1: 80.39,
    x2: 94.78,
    y2: 35.33,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "27") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M82.85,28.82c-9.41,11.59-15.27,26-23.38,38.66-6,9.46-13.32,17.93-19.42,27.35-12.16,18.76-19.5,41.63-18.16,64.48s12,45.41,29.77,57.92c10.91,7.69,23.82,11.34,36.66,13.71,43.23,8,89.76,1.84,126.7-23.67,6.34-4.38,12.41-9.32,19.29-12.64,17.67-8.54,40.59-6.56,53.4-22.24,7.71-9.44,9.41-22.94,9.15-35.53-.31-15.12-3.27-31-12.48-42.34-12-14.87-31.6-18.85-47.82-28C220.75,57.65,208,43.7,194.42,31.24,161.75,1.25,114.75-10.47,82.85,28.82Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#ff4289",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.59,152.93a6.76,6.76,0,0,1-2.13,4.94,7.09,7.09,0,0,1-4.23,1.92,5.26,5.26,0,0,1-.89,0l-49.67-1a7.31,7.31,0,0,1-7.23-7.19,6.8,6.8,0,0,1,2.11-4.95,7.27,7.27,0,0,1,5.12-2l1.69,0a13.84,13.84,0,0,1-.53-3.77,13.39,13.39,0,0,1,4.18-9.74,13.85,13.85,0,0,1,4-2.67,14.45,14.45,0,0,1,6.08-1.2l4.22.09A14.66,14.66,0,0,1,215,135.22a8.59,8.59,0,0,1,3.9-.83l1.09,0a8.68,8.68,0,0,1,8.59,8.53v.41a8,8,0,0,1-.34,2.3l4.11.08A7.34,7.34,0,0,1,239.59,152.93Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.23,159.79a5.26,5.26,0,0,1-.89,0l-49.67-1a7.31,7.31,0,0,1-7.23-7.19,6.8,6.8,0,0,1,2.11-4.95c-2,12.27,10.85,10.51,10.85,10.51h32.27Z",
    transform: "translate(-21.74 -3.78)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188,146.13l-3.61-1.37a13.84,13.84,0,0,1-.53-3.77,13.39,13.39,0,0,1,4.18-9.74,13.85,13.85,0,0,1,4-2.67C182.05,137.14,188,146.13,188,146.13Z",
    transform: "translate(-21.74 -3.78)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106,
    cy: 161.58,
    rx: 63.54,
    ry: 57.39,
    fill: "#ff4289",
    opacity: 0.23,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.63,155.85a61.13,61.13,0,0,1-12.35,36.92h0l-.13.18a61.37,61.37,0,1,1,12.48-37.1Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#ff4289"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.51,125.66c-3.37,1.39-7.09,1.72-10.55,2.86s-6.93,3.44-7.82,7c-.46,1.79-.22,3.78-1.1,5.4-1.17,2.18-3.91,3-5.57,4.8-3.16,3.48-1.08,9.45,2.78,12.14s8.79,3.1,13.41,3.89a6.35,6.35,0,0,1,3.46,1.37c2.69,2.57-.29,7.22.85,10.76.64,2,2.53,3.37,3.39,5.29,1.65,3.66-.85,7.7-2.5,11.36a28.22,28.22,0,0,0-.75,21.12,4.12,4.12,0,0,1-.38.47,61.81,61.81,0,0,1-17.81-11.86c-5.07-7.11-9.08-14.86-8.66-23.38.23-4.62,1.77-9.08,2.06-13.68.48-7.47-2.22-15.58,1.44-22.1,2-3.61,5.9-7.57,3.72-11.07-3.85.56-8,.65-11.53-.69a61.4,61.4,0,0,1,46.18-34.14C139.93,106.06,136.91,120.86,125.51,125.66Z",
    transform: "translate(-21.74 -3.78)",
    fill: "url(#linear-gradient-3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M206.63,155.85a61.25,61.25,0,0,1-1.09,11.57,41.62,41.62,0,0,0-4.57,4.33c-4.85,5.68-5.9,13.56-6.69,21h0c0,.16,0,.32-.05.47,0-.1,0-.19-.08-.29a12.35,12.35,0,0,0-2.43-5.23c-1.38-1.49-3.83-2.23-5.51-1.06q-1.2-3-2.41-5.95c-5,0-10.16,0-14.86-1.77s-8.59-5.16-12.35-8.47a82.61,82.61,0,0,0-.32-17.22,59.76,59.76,0,0,0,37.95-19.41,43.36,43.36,0,0,0-25,6.45c-1.6,1-3.22,2.12-5.09,2.28a11,11,0,0,1-3.5-.48L148.54,139c-1.51-7.78,3.88-15.59,10.81-19.44,5.2-2.88,11.51-2.32,16.5-4.84,3.42-1.72,4.42-4.73,7.41-6.94l.06,0A61.26,61.26,0,0,1,206.63,155.85Z",
    transform: "translate(-21.74 -3.78)",
    fill: "url(#linear-gradient-4)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.25,143.42c-.36,1.18-.7,2.56,0,3.55a3,3,0,0,0,1.31.93,3.59,3.59,0,0,0,3.73-.39,4.84,4.84,0,0,0,1.13-2.12,49.31,49.31,0,0,0,2-8.81,1.59,1.59,0,0,0,0-.84,1.43,1.43,0,0,0-.71-.64c-1.59-.85-4.08-1.53-5,.35C165.58,137.87,165.05,140.86,164.25,143.42Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#fbc4d6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M169.06,144.79a2.24,2.24,0,0,1,1,.09,1.76,1.76,0,0,1,.56.49l3.45,3.87c.67.75,1.37,1.78.9,2.67a2,2,0,0,1-1.48.88,8.77,8.77,0,0,1-4.84-.95c-1.06-.46-2.11-1-3.14-1.5a5.18,5.18,0,0,1-1.95-1.54c-.79-1.2-1-4.08.38-5,.71-.45,1.33-.13,2,.18A6.65,6.65,0,0,0,169.06,144.79Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#ff4289"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M183.37,156.6a1.48,1.48,0,0,1-.07.66,1.31,1.31,0,0,1-.5.49,4.28,4.28,0,0,1-2.22.75,2.58,2.58,0,0,1-2.09-.94,4.3,4.3,0,0,1-.65-1.93,22.45,22.45,0,0,1-.43-4.48.62.62,0,0,1,.59-.74c1.24-.26,3.71-.91,4.34.61A17.66,17.66,0,0,1,183.37,156.6Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#fbc4d6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.62,156.45a11.8,11.8,0,0,1,3.13.6,3.89,3.89,0,0,1,2.28,2.09,2.16,2.16,0,0,1,.07,1.5,3.23,3.23,0,0,1-1.7,1.61,21.68,21.68,0,0,1-11.58,2.49,4,4,0,0,1-2.81-1,4.4,4.4,0,0,1-.74-2.81l-.14-4.7a5.85,5.85,0,0,1,2.58.73c1.48.5,2.06-.7,3.28-1C184.58,155.59,187,156.29,188.62,156.45Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#ff4289"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M169.06,144.79a2.24,2.24,0,0,1,1,.09,1.76,1.76,0,0,1,.56.49l3.45,3.87c.67.75,1.37,1.78.9,2.67a2,2,0,0,1-1.48.88,8.77,8.77,0,0,1-4.84-.95c-1.06-.46-2.11-1-3.14-1.5a5.18,5.18,0,0,1-1.95-1.54c-.79-1.2-1-4.08.38-5,.71-.45,1.33-.13,2,.18A6.65,6.65,0,0,0,169.06,144.79Z",
    transform: "translate(-21.74 -3.78)",
    fill: "url(#linear-gradient-5)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M188.62,156.45a11.8,11.8,0,0,1,3.13.6,3.89,3.89,0,0,1,2.28,2.09,2.16,2.16,0,0,1,.07,1.5,3.23,3.23,0,0,1-1.7,1.61,21.68,21.68,0,0,1-11.58,2.49,4,4,0,0,1-2.81-1,4.4,4.4,0,0,1-.74-2.81l-.14-4.7a5.85,5.85,0,0,1,2.58.73c1.48.5,2.06-.7,3.28-1C184.58,155.59,187,156.29,188.62,156.45Z",
    transform: "translate(-21.74 -3.78)",
    fill: "url(#linear-gradient-6)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131.65,105.53a31.7,31.7,0,0,0-6.46.1,1.64,1.64,0,0,0-.79.25,1.4,1.4,0,0,0-.44,1c-.3,2.9,2,5.42,4.48,6.95,6.71,4.16,15.17,4,22.58,6.72a3.4,3.4,0,0,1,1.79,1.17,4.21,4.21,0,0,1,.44,2c.33,3.91,2.5,7.43,3.22,11.28s-.05,7.88.54,11.76c2.43-2.59,6.57-3,9-5.56,2.28-2.36,2.73-5.88,3.07-9.14l.92-8.94a2.74,2.74,0,0,0-1.62-3.24C157.44,112.81,144.62,106.65,131.65,105.53Z",
    transform: "translate(-21.74 -3.78)",
    fill: "url(#linear-gradient-7)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M175.89,104.63A5.69,5.69,0,0,1,178.6,106a5.48,5.48,0,0,1,1,3.76,76.27,76.27,0,0,1-5.29,27.72,1.91,1.91,0,0,1-2.79,1.49,63,63,0,0,1-6.14-2l2.72-18a2.5,2.5,0,0,0-.08-1.51,2.44,2.44,0,0,0-.82-.84,72.33,72.33,0,0,0-9.8-6c-2.73-1.38-5.86-3-6.6-5.92a3.25,3.25,0,0,1,.54-2.95,4.81,4.81,0,0,1,1.5-1c1.81-.89,4.09-2,6.17-1.82,1.67.17,2.31,1.13,3.7,1.84C166.57,102.69,171.7,103.41,175.89,104.63Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#282328"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M157.31,76c1.34,3.69,2,7.6,3.18,11.33a7.29,7.29,0,0,0,1.36,2.71,7.5,7.5,0,0,0,3,1.76q2.35.91,4.78,1.59c1.08.29,2.37.79,2.49,1.89a2,2,0,0,1-.22,1.06,5,5,0,0,1-4.16,2.55,13.46,13.46,0,0,1-5-.82A7.51,7.51,0,0,1,158.9,96a8.13,8.13,0,0,1-1.23-2.9,82.51,82.51,0,0,0-6.79-16.78,19,19,0,0,1-2-4.5c-.66-2.76-.67-9.3,2.18-6.9C153.36,66.86,156.3,73.26,157.31,76Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#fbc4d6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M146.4,104.28a40.64,40.64,0,0,0,4.91-2.29c6-3.32,1.09-4.95-.91-8.94-1.43-2.83-.85-6.22-.11-9.29,1.31-5.4,3.06-11,1.8-16.39a6.3,6.3,0,0,0-1-2.44,6.89,6.89,0,0,0-1.26-1.21,13.6,13.6,0,0,0-4.3-2.51c-3-1-6.4-.27-9.25,1.16-11.2,5.62-13.59,19.81-13.14,31.16.12,3.15.61,6.48,2.64,8.89s4.9,3.33,7.84,3.69A26.71,26.71,0,0,0,146.4,104.28Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M129.7,97.86a6.73,6.73,0,0,0,1,3c1,1.41,2.84,1.93,4.53,2.34l7.61,1.88a10,10,0,0,0,2.86.43c2.08-.1,3.87-1.43,5.52-2.71a4.23,4.23,0,0,0,1.08-1.07c-4.2-.4-8.39-.82-12.57-1.43-2.46-.36-5.06-.86-6.87-2.55a8.62,8.62,0,0,1-2.08-3.29c-.3-.77-.44-2.73-1.31-2.9A22.52,22.52,0,0,0,129.7,97.86Z",
    transform: "translate(-21.74 -3.78)",
    fill: "url(#linear-gradient-8)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M144.72,70a1.19,1.19,0,0,1-.35.84,1.08,1.08,0,0,1-.69.14,5.49,5.49,0,0,1-5.14-6.49c.18-1,.61-1.86.88-2.8.53-1.88.44-4,1.63-5.55A62.17,62.17,0,0,0,144.57,63a3.72,3.72,0,0,1,.66,3.13Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#fbc4d6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M145.31,65.16l-.45,3s-5.15-2.55-4.48-7.28S145.31,65.16,145.31,65.16Z",
    transform: "translate(-21.74 -3.78)",
    fill: "url(#linear-gradient-9)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M151.33,62.24a4.75,4.75,0,0,1-1.6,2.44,3.6,3.6,0,0,1-1.22.53,7.39,7.39,0,0,1-7.87-3.67,10.81,10.81,0,0,1-.42-9,6.31,6.31,0,0,1,3-3.71,5.15,5.15,0,0,1,4.84.57,11.79,11.79,0,0,1,4.21,5.32C153,56.91,152.08,60.15,151.33,62.24Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#fbc4d6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M173.94,117.2a19.49,19.49,0,0,1,3,5.41,107.66,107.66,0,0,1,7.59,29.69,39.11,39.11,0,0,1-9.67,0A90.56,90.56,0,0,0,171.55,131a13.76,13.76,0,0,0-1.75-4.22c-1.43-2.07-3.78-3.27-6-4.39a88.48,88.48,0,0,0-16.21-6c-2.36-.65-4.74-1.25-7.06-2-1.95-.66-7.42-3.08-9-4.39a7.71,7.71,0,0,1-3-5.25c0,.52,15.24,1.56,16.33,1.44,3.67-.39,8-2.49,11.62-1,2.83,1.16,5.42,3.58,8,5.25C167.61,112.4,171.43,114.3,173.94,117.2Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#473f47"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "135.5 112.65 116.9 103.56 138.71 94.31 157.32 102.44 135.5 112.65",
    fill: "#ff4289"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M128.91,73.75c0,.35-.09.69-.13,1-.55,5.12-.05,10.14.14,15.23.12,3.15.53,9.15,3.88,10.76,6.26,3,18.34,1.86,18.34,1.86a10.64,10.64,0,0,1,4.21.17c.75.23,1.44.62,2.17.9,2.64,1,5.59.5,8.37,0a3.58,3.58,0,0,0,1.36-.45,2.47,2.47,0,0,0,.23-3.46,6.35,6.35,0,0,0-3.36-1.85,19.88,19.88,0,0,0-10.86-.42,12.12,12.12,0,0,1-1.4.38,9.43,9.43,0,0,1-1.68.12l-4.26,0c-4.9,0-9.52.06-10.26-5.67a31.12,31.12,0,0,1-.16-6.4c.29-3.85,1.3-7.67,1.09-11.52a7.64,7.64,0,0,0-.89-3.5,3.56,3.56,0,0,0-2.94-1.86,3.67,3.67,0,0,0-3,2A8,8,0,0,0,128.91,73.75Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#fbc4d6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "164.98 84.1 138.98 97.33 135.5 112.65 157.32 102.44 164.98 84.1",
    fill: "#ff4289"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M152.61,56.72a4.18,4.18,0,0,0-1-2.59,4.42,4.42,0,0,0-1.1-.92c-.58-.34-.72-.37-1.1.18-.49.71-.65,1.54-1.1,2.28a5.83,5.83,0,0,1-2,2,5.42,5.42,0,0,1-3.08.81,4.35,4.35,0,0,0-1.3,0,1,1,0,0,0-.69.5,3.34,3.34,0,0,0-.11,1.15c-.09,1-1.08,1.71-1.63,2.58s-.71,2.16-1.37,3.09a1.29,1.29,0,0,1-.49.44c-.47.2-1-.06-1.49-.15-1.45-.25-2.62,1.1-3.86,1.92-2.49,1.64-5.75,1.22-8.69.73A8.65,8.65,0,0,1,121,68a8.76,8.76,0,0,1-2.33-2c-1.09-1.2-2.17-2.42-3.24-3.64a4.21,4.21,0,0,1-.93-1.37,2.46,2.46,0,0,1-.09-1.11,6.71,6.71,0,0,1,.61-2c.78-1.75,1.69-3.65,3.45-4.44s3.84-.2,5.78-.4a1.15,1.15,0,0,0,.66-.21,1.44,1.44,0,0,0,.32-.61c.81-2.69,1.82-5.61,4.24-7a9.71,9.71,0,0,1,6-.79,23.69,23.69,0,0,0,6.11.35c1-.16,2-.49,3-.69a9.79,9.79,0,0,1,6.88,1A7.26,7.26,0,0,1,155,51a8.28,8.28,0,0,0,0,1.41c.07.44.26.87.33,1.31A2.71,2.71,0,0,1,152.61,56.72Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#ff681c"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M128,76.59a44.09,44.09,0,0,0-.1,8.52,1.22,1.22,0,0,0,.18.7,1.24,1.24,0,0,0,.82.4,27.87,27.87,0,0,0,4.91.47,1.65,1.65,0,0,0,2.14-1.37c.9-3.76,1.79-7.52,2.47-11.33.27-1.53.46-3.25-.46-4.49-1.33-1.8-4.92-2-6.65-.69C129.22,70.41,128.33,74.17,128,76.59Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M156.3,71.79l2.83,6.78a1.46,1.46,0,0,1,.16.86,1.36,1.36,0,0,1-.4.63,16.31,16.31,0,0,1-4.84,3.52,16.9,16.9,0,0,1-4-5.34c-.94-2.41-.73-5.09-.45-7.66.17-1.63.11-6.87,2.88-4.84C154.41,67.13,155.43,69.7,156.3,71.79Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M105.11,135.39a6.8,6.8,0,0,1-2.12,4.94,7.12,7.12,0,0,1-4.23,1.92,8.7,8.7,0,0,1-.89,0l-49.67-1a7.32,7.32,0,0,1-7.24-7.2,6.8,6.8,0,0,1,2.12-4.94,7.17,7.17,0,0,1,5.12-2l1.69,0a13.54,13.54,0,0,1-.53-3.78,13.38,13.38,0,0,1,4.18-9.74,13.68,13.68,0,0,1,4-2.66,14.42,14.42,0,0,1,6.08-1.2l4.22.09a14.69,14.69,0,0,1,12.67,7.74,8.86,8.86,0,0,1,3.9-.83l1.09,0a8.69,8.69,0,0,1,8.58,8.54v.41a7.83,7.83,0,0,1-.33,2.29l4.11.09A7.32,7.32,0,0,1,105.11,135.39Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M98.76,142.25a8.7,8.7,0,0,1-.89,0l-49.67-1a7.32,7.32,0,0,1-7.24-7.2,6.8,6.8,0,0,1,2.12-4.94c-1.95,12.26,10.85,10.51,10.85,10.51H86.2Z",
    transform: "translate(-21.74 -3.78)",
    fill: "url(#linear-gradient-10)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M53.49,128.59l-3.6-1.37a13.54,13.54,0,0,1-.53-3.78,13.38,13.38,0,0,1,4.18-9.74,13.68,13.68,0,0,1,4-2.66C47.57,119.6,53.49,128.59,53.49,128.59Z",
    transform: "translate(-21.74 -3.78)",
    fill: "url(#linear-gradient-11)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M236.13,77.27A6.78,6.78,0,0,1,234,82.21a7.15,7.15,0,0,1-4.24,1.92,5.21,5.21,0,0,1-.89,0l-49.66-1A7.31,7.31,0,0,1,172,76a6.8,6.8,0,0,1,2.11-5,7.3,7.3,0,0,1,5.13-2l1.68,0a13.84,13.84,0,0,1-.53-3.77,13.39,13.39,0,0,1,4.18-9.74,13.76,13.76,0,0,1,4-2.67,14.39,14.39,0,0,1,6.08-1.2l4.22.09a14.66,14.66,0,0,1,12.66,7.75,8.62,8.62,0,0,1,3.9-.83l1.09,0a8.68,8.68,0,0,1,8.59,8.53v.41a8,8,0,0,1-.34,2.3l4.11.08A7.34,7.34,0,0,1,236.13,77.27Z",
    transform: "translate(-21.74 -3.78)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M229.77,84.13a5.21,5.21,0,0,1-.89,0l-49.66-1A7.31,7.31,0,0,1,172,76a6.8,6.8,0,0,1,2.11-5c-2,12.27,10.85,10.51,10.85,10.51h32.27Z",
    transform: "translate(-21.74 -3.78)",
    fill: "url(#linear-gradient-12)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M184.51,70.47,180.9,69.1a13.84,13.84,0,0,1-.53-3.77,13.39,13.39,0,0,1,4.18-9.74,13.76,13.76,0,0,1,4-2.67C178.59,61.48,184.51,70.47,184.51,70.47Z",
    transform: "translate(-21.74 -3.78)",
    fill: "url(#linear-gradient-13)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M142,58.5a1,1,0,0,0-.69.5,3.34,3.34,0,0,0-.11,1.15c-.09,1-1.08,1.71-1.63,2.58s-.71,2.16-1.37,3.09a1.29,1.29,0,0,1-.49.44c-.47.2-1-.06-1.49-.15-1.45-.25-2.62,1.1-3.86,1.92-2.49,1.64-5.75,1.22-8.69.73A8.65,8.65,0,0,1,121,68a8.76,8.76,0,0,1-2.33-2c-1.09-1.2-2.17-2.42-3.24-3.64a4.21,4.21,0,0,1-.93-1.37,2.46,2.46,0,0,1-.09-1.11,12.41,12.41,0,0,1,1.45-.75,6.73,6.73,0,0,1,5-.55c1.34.52,2.29,1.71,3.44,2.56a8.25,8.25,0,0,0,10.64-1,9.17,9.17,0,0,1,1.76-1.76C137.89,57.73,140.31,57.83,142,58.5Z",
    transform: "translate(-21.74 -3.78)",
    fill: "url(#linear-gradient-14)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcaseIllustration);
export default __webpack_public_path__ + "static/media/showcaseIllustration.8791a75cddc36ec661cdb3d9883cd7ea.svg";
export { ForwardRef as ReactComponent };